/* unplugin-vue-components disabled */import script from "./StagePage.vue?vue&type=script&setup=true&lang=js"
export * from "./StagePage.vue?vue&type=script&setup=true&lang=js"

import "./StagePage.vue?vue&type=style&index=0&id=c3c62330&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c3c62330"]])

export default __exports__